import React from 'react'
import { Row, Col } from 'antd'

const ExpandedData = ({ data }) => {
    let table = [
        { heading: "Message ID", data: data.id },
        { heading: "Full Name", data: data.fullName },
        { heading: "Email", data: data.email },
        { heading: "Phone", data: <a href={`tel:+${data.phone}`} target="_blank" rel="noopener noreferrer">{data.phone}</a> },
        { heading: "WhatsApp", data: <a href={`https://wa.me/${data.whatsapp}`} target="_blank" rel="noopener noreferrer">{data.whatsapp}</a> },
        { heading: "Country", data: data.country?.name },
        { heading: "Province", data: data.province?.name },
        { heading: "City", data: data.city?.name },
        { heading: "Subject", data: data.subject },
        { heading: "Message", data: data.content },
        { heading: "Type", data: data.type, className: "text-capitalize" },
        { heading: "Status", data: data.status, className: "text-capitalize" },
        { heading: "Date Created", data: window.dateFormat(data.createdAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
    ]
    return (
        <>
            <Row>
                <Col xs={24} md={{ span: 14, offset: 5 }}>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered table-hover align-middle mb-0">
                            <tbody>
                                {table.map((row, i) => {
                                    return <tr key={i}>
                                        <th>{row.heading}</th>
                                        <td className={row.className || ""}>{row.data}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ExpandedData